<template>
	<div id="mapLegend" class="mapboxgl-ctrl mapboxgl-ctrl-group">
		<div class="legend-group">
			<div class="legend-header">
				<i class="material-icons md-14">remove_red_eye</i>
				zoning
			</div>
			<div class="legend-list">
				<div v-for="(row, index) in groups.zoning.rows" :key="row.label" class="legend-row">
					<span class="legend-swatch" :style="swatchStyle(row)">
					</span>
					<span class="legend-label">
						{{row.label}}
					</span>
				</div>
			</div>
		</div>
		<div class="legend-group off">
			<div class="legend-header">
				<i class="material-icons md-14">remove_red_eye</i>
				overlays
			</div>
		</div>
	</div>
</template>

<script>

const groups = {
	zoning:{
		rows:[
			{label:'residential (i)',color:'#FFAB00'},
			{label:'residential (ii)',color:'#FFAB00'},
			{label:'mixed use',color:'#E65100'},
			{label:'commercial',color:'#B61D1D'},
			{label:'government',color:'#C2195B'},
			{label:'industrial',color:'#6A1B9A'},
			{label:'open space',color:'#558B2F'}
		]
	}
};

export default {
	name:'map-legend',
	computed: {
		satellite:function(){
			return (this.$store.state.map.params.style === 'satellite')? true: false;
		}
	},
	data:function(){
		return {
			groups:groups
		}
	},
	methods:{
		toggleStyle: function(){			
        	if (this.$store.state.map.params.style == 'satellite') {
        		this.$store.dispatch('MAP_PARAMS_SET', {style: 'vector'});
        		return;
			}

        	this.$store.dispatch('MAP_PARAMS_SET', {style: 'satellite'});
		},
		swatchStyle:function(row){
			return 'background-color:'+row.color+';';
		}
	},
	mounted:function(){

	}
}
</script>

<style>

#mapLegend{
	min-width:90px;
}
#mapLegend img{
	width:100%;
}
#mapLegend .legend-row{
	line-height:15px;
}
#mapLegend .legend-label{
	font-size:10px;
	line-height:14px;
	vertical-align:middle;
}
#mapLegend .legend-list{
	padding:0.1rem 0.25rem;
}
#mapLegend .legend-group{
}
#mapLegend .legend-group.off{
	background-color:#CFD8DD;
}
#mapLegend .legend-group.off i{
	color:#8FA3AE;
}
#mapLegend .legend-header{
	cursor:pointer;
	border-bottom:1px solid #EEE;
	padding:0 .25rem;
	font-size:11px;
}
#mapLegend .legend-group.off .legend-header:hover{
	background-color:#EDEFF1;
}
#mapLegend .legend-group.off .legend-header:hover i{
	color:#788F9C;
}
#mapLegend .legend-group.off .legend-header{
	border-bottom:none;
}
#mapLegend .legend-swatch{
	width:12px;
	height:12px;
	display:inline-block;
	vertical-align:middle;
	margin-right:2px;
}
</style>


// WEBPACK FOOTER //
// src/components/map/map-legend.vue